import { FacilityAdd } from '#app/routes/mocra+/_form+/components/facilities/add.tsx'
import { FacilityCard } from '#app/routes/mocra+/_form+/components/facilities/card.tsx'
import { type FacilityDraft } from '#app/routes/mocra+/_form+/components/facilities/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type FacilityListItem = {
	readonly draft: FacilityDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly facilities: ReadonlyArray<FacilityListItem>
	readonly onAdd: (draft: FacilityDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
	readonly emptyState?: string
}

export function FacilityRosterSection({
	resources,
	facilities,
	onAdd,
	onEdit,
	onRemove,
	emptyState,
}: Props) {
	return (
		<Section
			title="Facility roster"
			description="Add owned plants and contract manufacturers that need MoCRA registration coverage."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{facilities.length > 0 ? (
					facilities.map((facility, index) => {
						const errors = facility.errors
						return (
							<FacilityCard
								key={`facility-${index}`}
								index={index}
								facility={facility.draft}
								errors={errors.length > 0 ? [...errors] : undefined}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						{emptyState ??
							'Start the roster with each site that manufactures or stores your products.'}
					</p>
				)}
			</div>
			<FacilityAdd onSubmit={onAdd} />
		</Section>
	)
}
